

















































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { ContractSymbol, WatchSymbol, Sort, TransactionItem, OtmRange } from '@/services/data'
import draggable from 'vuedraggable'
import utility from '@/common/utility'
import SymbolSearch from '@/components/SymbolSearch.vue'
import SetSymbolAlert from '@/components/SetAlertPrice.vue'
import NumberRowEditor from '@/components/NumberRowEditor.vue'
import checkListService from '@/services/checkListService'
import freebieService from '@/services/freebieService'
import TransactionForm from '@/components/TransactionForm.vue'
import SymbolName from '@/components/SymbolName.vue'
import transService from '@/services/transService'
import RangeForm from '@/components/RangeForm.vue'

@Component({
  components: {
    draggable,
    SymbolSearch,
    SetSymbolAlert,
    NumberRowEditor,
    TransactionForm,
    SymbolName,
    RangeForm
  }
})
export default class WatchSymbols extends Vue {
  name = 'WatchSymbols'
  @Prop() Items: WatchSymbol[]
  @Prop() Keys: string[]
  @Prop() IsRead: boolean
  @Prop() IsSystem: boolean
  @Prop() draggable: boolean
  showSymbolSearch = false
  alertPriceSettingDialog = false
  sort: Sort = { key: null, direction: null }
  currentSymbol: WatchSymbol
  showTargetDialog = false
  showTransDialog = false
  editingTarget: number
  showRangeDialog = false
  currentSymbolRange: OtmRange = { Low: null, High: null, SymbolId: null }

  $num (num: number): string {
    if (num != null && num !== undefined) {
      return num.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
    }
    return null
  }

  $fix (num: number, end?: string): string {
    if (num != null && num !== undefined) {
      return num.toFixed(2) + (end || '')
    }
    return null
  }

  sortItems (key: string, direction: string) {
    this.sort = { key, direction }
    const sort = (a: WatchSymbol, b: WatchSymbol): number => {
      const v = direction === 'Asc' ? 1 : -1
      const left = this.getByKey(a, key)
      const right = this.getByKey(b, key)
      if (left === right) return 0
      return left > right ? v : v * -1
    }
    if (sort) {
      this.Items.sort(sort)
    }
  }

  getByKey = utility.getByKey

  @Emit('dragEnd')
  async dragEnd () {
    for (let i = 0; i < this.Items.length; i++) {
      this.Items[i].Rank = i + 1
    }
  }

  @Emit('addSymbol')
  async addSymbol (item: ContractSymbol) {
    this.showSymbolSearch = false
    return item
  }

  @Emit('deleteSymbol')
  delItem (item: WatchSymbol) {
    return item
  }

  @Watch('Items')
  onItemsChanged (v: any) {
    if (this.IsSystem) {
      const tid = parseInt(this.$route.query.targetSymbolId as string)
      const find = this.Items.find(p => p.Symbol.SymbolId === tid)
      if (find) {
        this.showEditTarget(find)
      }
    }
  }

  @Emit('transChanged')
  async addTransaction (item: TransactionItem) {
    item.SymbolId = this.currentSymbol.Symbol.SymbolId
    const res = await transService.addOrUpdateTransaction(item)
    if (res.Error) {
      await this.$alert(res.Error)
    } else {
      this.showTransDialog = false
    }
  }

  alertAdded (res: { symbolId: number; count: number }) {
    this.currentSymbol.Alert = res.count > 0
  }

  async targetSaved () {
    const targetValue = this.editingTarget
    const res = await checkListService.setTargetAsync({
      SymbolId: this.currentSymbol.Symbol.SymbolId,
      Target: targetValue
    })
    if (res.Error) {
      await this.$alert(res.Error)
    } else {
      const find = this.Items.find(p => p.Symbol.SymbolId === this.currentSymbol.Symbol.SymbolId)
      if (find) {
        find.Target = targetValue
      }
      this.showTargetDialog = false
    }
  }

  showEditTarget (item: WatchSymbol) {
    const find = this.Items.find(p => p.Symbol.SymbolId === item.Symbol.SymbolId)
    if (find) {
      this.editingTarget = find.Target
    }
    this.currentSymbol = item
    this.showTargetDialog = true
  }

  async openRangeEditor (item: WatchSymbol) {
    this.currentSymbol = item
    const ranges = await freebieService.getOtmRanges(item.Symbol.SymbolId)
    if (ranges.Result && ranges.Result.length > 0) {
      const range = ranges.Result.find(p => p.RangeType === 'Download')
      this.currentSymbolRange = { SymbolId: item.Symbol.SymbolId, Low: range?.Low, High: range?.High, Run: range?.Run }
    } else {
      this.currentSymbolRange = { Low: null, High: null, SymbolId: item.Symbol.SymbolId, Run: false }
    }
    this.showRangeDialog = true
  }

  async saveDownloadRange (model: { Low: number; High: number;Run: boolean }) {
    const res = await freebieService.updateRange({
      SymbolId: this.currentSymbol.Symbol.SymbolId,
      Low: model.Low,
      High: model.High,
      Run: model.Run,
      RangeType: 'Download'
    })
    if (res.Error) {
      await this.$alert(res.Error)
    } else {
      this.showRangeDialog = false
      if (this.currentSymbol != null) {
        this.currentSymbol.IsDownload = model.Run
      }
    }
  }

  showAddTranForm (item: WatchSymbol) {
    this.currentSymbol = item
    this.showTransDialog = true
  }

  async setAlertPrice (item: WatchSymbol) {
    if (item) {
      this.currentSymbol = item
      this.alertPriceSettingDialog = true
    }
  }
}
